export function timeout(ms: number): Promise<string> {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve('timeout');
    }, ms)
  );
}
